






import Vue from 'vue';
import { Icon } from '@/components/ds';
import pipeline from '@/pipeline';

export default Vue.extend({
  components: { Icon },
  methods: {
    clickHandler() {
      if (pipeline.initialized) pipeline.prev();
    },
  },
});
